import React, { useDebugValue, useEffect, useMemo, useState } from "react";
import TabsMobile from "../__template/TabsMobileComponent";
import donation from "../../assets/images/icon_donation/donation.svg";
import { getDonations } from "../../core/service/api_donation";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../core/feature/hooks";
import CustomApp from "../../core/models/customApp";
import { isDarkColor } from "../../config/DarkColorChecker";

const ComponentDonation = () => {
  const lang: String = useAppSelector((state) => state.language.language);

  const [data, setData] = useState<any>([]);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [size, setSize] = useState(15);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const currentSize = useMemo(() => {
    const a = data.length;
    const b = a / (page + 1);
    console.log("b", a, b);

    return b;
  }, [data]);

  const addMore = async () => {
    setPage(page + 1);
    dispatch(setLoading(true));
    getDonations(page + 1, size)
      .then((res) => {
        dispatch(setLoading(false));
        setData(data.concat(res.data.content));
        console.log(res.data);
      })
      .catch((err) => {
        dispatch(setLoading(false));
      });
  };

  const getData = async () => {
    dispatch(setLoading(true));
    getDonations(page, size)
      .then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data.content);
        setTotal(res.data.totalElements);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
      });
  };

  const goToDetail = async (data: any) => {
    navigate("/donation-detail", { state: { data: JSON.stringify(data) } });
  };
  useEffect(() => {
    setPage(0)
    getData()
  }, []);

  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className={`px-8 pt-8 pb-3  sticky top-0 z-50 bg-white`}>
        <TabsMobile
          name={`${t("DONATION.title")}`}
          backUrl={"home"}
        ></TabsMobile>
      </div>
      <section className="px-4 py-6 flex flex-col gap-3 top-to-bottom">
        {data.map((res: any) => (
          <div
            onClick={() => goToDetail(res)}
            className="bg-white p-3 rounded-xl flex-row flex gap-3 items-center shadow-md shadow-slate-200"
          >
            <img src={donation} className="w-9 h-9 rounded-full" />
            <div className="flex flex-col gap-1.5">
              <h1 className="m-0 font-montserrat text-xs  font-medium text-psp-nav">
                {res.title}
              </h1>
              <span
                style={{ fontSize: 9 }}
                className="font-montserrat font-medium text-psp-gray"
              >
                {moment(res.createDate).format("LL")}
              </span>
            </div>
          </div>
        ))}
        { (page + 1) * size <= total && (
          <div className="flex w-full">
            <button
              onClick={addMore}
              style={{ background: customApp?.app_accent_color }}
              className={`w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active ${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'}`}
            >
              {t("OTHER.showMore")}
            </button>
          </div>
        )}
      </section>
    </div>
  );
};

export default ComponentDonation;
